import { PeriodoOption } from './types';

const PERIODO_OPTIONS: PeriodoOption[] = [
  { label: 'Últimos 7 dias', value: '7dias' },
  { label: 'Últimos 30 dias', value: '30dias' },
  { label: 'Período customizado', value: 'customizado' },
];

export default PERIODO_OPTIONS;
